/**
 * Add-to-basket button
 * 
 * Tiny component to render added/not-added state.
 */
export default class AddToBasketButton {
    /** @type {Map<Number, AddToBasketButton>} */
    static instances = new Map();

    /** @type {HTMLElement} */
    buttonElem = null;

    /** @type {boolean} */
    isAdded = false;

    /** @param {HTMLElement} buttonElem */
    constructor(buttonElem) {
        this.buttonElem = buttonElem;

        if (buttonElem && buttonElem.classList.contains('is-toggled')) {
            this.isAdded = true;
        }

        this.render();
    }

    /** @param {boolean} isAdded */
    setIsAdded(isAdded) {
        this.isAdded = isAdded;

        this.render();
    }

    getIsAdded() {
        return this.isAdded;
    }

    render() {
        if (this.buttonElem) {
            this.buttonElem.classList.toggle('is-toggled', this.isAdded);
        }
    }

    static init() {
        const elems = document.querySelectorAll('.add-to-basket');

        elems.forEach(elem => {
            const itemId = elem.dataset.item;

            AddToBasketButton.instances.set(itemId, new AddToBasketButton(elem));
        });

        window.AddToBasketButton = AddToBasketButton;
    }

    static setIsAdded(itemId, isAdded) {
        const instance = AddToBasketButton.instances.get(itemId.toString());

        if (instance) {
            instance.setIsAdded(isAdded);
        }
    }

    static getIsAdded(itemId) {
        const instance = AddToBasketButton.instances.get(itemId.toString());

        if (instance) {
            return instance.getIsAdded();
        }

        return false;
    }
}